let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkcIt")).then(() => parcelRequire('9wtbc'));